const CiCWorkflowStages = {
  Draft: 1,
  PendingReview: 4,
  UnderInitialReview: 5,
  PendingExpertReview: 8,
  UnderExpertReview: 9,
  Complete: 100,
  Closed: 200
};

export default CiCWorkflowStages;
